<div #pagesHost
     (click)="onHostClick()"
     (contextmenu)="$event.preventDefault()"
     (keydown.enter)="onHostClick()"
     (keydown.space)="onHostSpace($event)"
     [attr.aria-label]="small ? 'View ' + title : title"
     [attr.role]="small ? 'button' : 'document'"
     [attr.tabindex]="small ? 0 : 0"
     [class.small]="small"
     class="pdfPages">
</div>
@if (loading) {
    <div class="pdfLoading">
        <mat-progress-spinner aria-label="Loading document" color="accent"
                              mode="indeterminate"></mat-progress-spinner>
    </div>
}
